export default __webpack_public_path__ + "static/klarity-446edcf150f08ca65248bba0199ae5ed.png";